import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const attributeColorPickerK = {
  changeColorSystem: "attribute_color_picker.changeColorSystem",
  chooseRalColor: "attribute_color_picker.chooseRalColor",
  chooseNcsColor: "attribute_color_picker.chooseNcsColor",
  chooseColorSystemTitle: "attribute_color_picker.chooseColorSystemTitle",
};

export const useAttributeColorPickerT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      changeColorSystem: t(attributeColorPickerK.changeColorSystem),
      chooseRalColor: t(attributeColorPickerK.chooseRalColor),
      chooseNcsColor: t(attributeColorPickerK.chooseNcsColor),
      chooseColorSystemTitle: t(attributeColorPickerK.chooseColorSystemTitle),
    }),
    [i18n.language]
  );
};